export default __webpack_public_path__ + "static/media/seta-direita.98fa472a.png";